import { create } from "zustand";

type CheckoutState = {
  checkoutId?: string;
  paymentId?: string;
  setCheckoutId: (id: string) => void;
  setPaymentId: (id: string) => void;
};

export const useCheckoutStore = create<CheckoutState>((set) => ({
  checkoutId: localStorage.getItem("melhot_checkout_id") ?? undefined,
  paymentId: localStorage.getItem("melhot_payment_id") ?? undefined,
  setCheckoutId: (checkoutId) => {
    localStorage.setItem("melhot_checkout_id", checkoutId);
    set({ checkoutId });
  },
  setPaymentId: (paymentId) => {
    localStorage.setItem("melhot_payment_id", paymentId);
    set({ paymentId });
  }
}));
